import type { Release } from '../releases.ts';

export default {
  version: '0.22.2',
  date: '2026-10-05',
  title: 'Smoother sequence preview in Safari at start and at cuts',
  summary: [
    'Fixed: the sequence preview in Safari no longer stutters when you press Play or at cuts and transitions',
  ],
  features: [],
  fixes: [
    'The sequence preview in Safari no longer stutters when you press Play or at cuts and transitions: Play now starts the clock when the picture really appears, and the next clip is started shortly before its cut (hidden and silent) so it is already running when the cut arrives; a split that removed nothing keeps playing the same clip without any switch',
  ],
} satisfies Release;
